import { FireFilled } from '@ant-design/icons'
import { Tag } from 'antd'

const renderStampOrderUrgent = (urgent?: boolean) =>
    urgent ? (
        <Tag key='stamp-order-urgent' color='error' icon={<FireFilled/>}>
            Срочно
        </Tag>
    ) : null

export default renderStampOrderUrgent
